var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Grid from "@mui/material/Grid";
import { ApAutocomplete } from "./ApAutocomplete";
export var ApAutocompleteGridItem = function (props) {
    return (_jsx(Grid, __assign({ item: true, xs: props.xs, sx: props.gridSx }, { children: _jsx(ApAutocomplete, { label: props.label, formik: props.formik, name: props.name, options: props.options, multiple: props.multiple, limitTags: props.limitTags, size: props.size, disableCloseOnSelect: props.disableCloseOnSelect, autocompleteSx: props.autocompleteSx, fullWidth: props.fullWidth }) })));
};
